import type { ComponentPropsWithoutRef, ElementType } from 'react';

import classNames from 'classnames';

import styles from './Typeset.module.css';

export const typesetClassName = styles.root;
const compactTypesetClassName = styles.compact;

type TypesetOwnProps<T extends ElementType> = {
  component?: T;
  compact?: boolean;
  className?: string;
};

export type TypesetProps<T extends ElementType = 'div'> = TypesetOwnProps<T> &
  Omit<ComponentPropsWithoutRef<T>, keyof TypesetOwnProps<T>>;

export const Typeset = <T extends ElementType = 'div'>({
  component,
  compact = false,
  className,
  ...props
}: TypesetProps<T>) => {
  const Component = component ?? 'div';

  return (
    <Component
      className={classNames(
        typesetClassName,
        compact && compactTypesetClassName,
        className,
      )}
      {...props}
    />
  );
};
